import React, { useState, useEffect } from 'react'
import AddProduct from './add-product'
import TabDetails from './tab-details'
import useProduct from '../../hooks/useProduct'
import { TabsContainer, TabsInner, Tab } from './styles'

const Tabs = ({ title, tabsArray, imageNode, locale }) => {

	const [activeBtn, setActiveBtn] = useState(tabsArray)
	const [activeSlug, setActiveSlug] = useState(tabsArray[0].slug)
	const [sessionSlug, setCurrentSessionSlug] = useState(tabsArray[0].slug)
	const [split, setSplit] = useState([])
	const [addProductDetails, setAddProductDetails] = useState([])
	const [tabDetails, setTabDetails ] = useState([])

	const activeTabHandler = (index, slug) => {
		let active = activeBtn.map((x, i) => {
			return i === index ? { ...x, active: true } : { ...x, active: false }
		})
		setActiveSlug(slug)
		setActiveBtn(active)
	}
	useEffect(() => {
		const windowHash = window.location.hash
		const splitWindowHash = windowHash.split('#').join('')
		setSplit(splitWindowHash)
	})

	useEffect(() => {
		if (split === '') {
			sessionStorage.setItem('comparisontab', activeSlug)
			setCurrentSessionSlug(activeSlug)
			const firstBtnActive = { ...activeBtn[0], active: true }
			const btns = [...activeBtn]
			btns[0] = firstBtnActive
			setActiveBtn(btns)
		} else if (split != '') {
			let xx = activeBtn.map(x => {
				return x.slug === split
					? { ...x, active: true }
					: { ...x, active: false }
			})
			setActiveBtn(xx)
			sessionStorage.setItem('comparisontab', split)
			setCurrentSessionSlug(split)
		}

		return () => {
			sessionStorage.removeItem('comparisontab')
		}
	}, [activeSlug, split])

	const getDatas = (dits) => {
		const parsedDetails = JSON.parse(dits)
		setAddProductDetails(parsedDetails)
	}
	
	const getTabDetails = (tabDits) => {
		const parsedDetails = JSON.parse(tabDits)
		setTabDetails(parsedDetails)
	}

	const active = activeBtn.filter(item => item.active === true)
	const dolphinTag = activeBtn.filter(item => item.tag ? item.active === true ? item.tag : '' : '')

	const { tabDataSummary } = useProduct()

  return (
		<TabsContainer>
			<TabsInner>
				{activeBtn.map((item, i) => {
					return (
						<Tab
							key={i}
							className={item.active ? 'active' : ''}
							href={`#${item.slug}`}
							onClick={(e) => {
								getTabDetails(tabDataSummary(item.tag ? item.tag : item.slug))
								activeTabHandler(i, item.slug)
							}}
						>
							{item.tabName}
						</Tab>
					)
				})}
				<AddProduct {...{ title, active, dolphinTag, getDatas, imageNode, locale }} />
			</TabsInner>
			<TabDetails activeSlug={sessionSlug} addDetails={addProductDetails} removeAddDits={setAddProductDetails} tabDetails={tabDetails} locale={locale}/>
		</TabsContainer>
	)
}

export default Tabs
